import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";

export var notesListRes;
export const notesListTodo = createAsyncThunk('notesList', async (id) => {
    let user_id = JSON.parse(localStorage.getItem('user_data'))
    try {
        const res = await axios({

            method: "post",
            url: process.env.REACT_APP_API_URL + 'learner/view_note_details',
            data: {
                "user_id": user_id.vemp_code,
                "user_role": user_id.vrole_name,
                "course_id": id.course_id,
                "device_token": user_id.vdevice_token
            },
            mode: 'no-cors',
            headers: { "Content-Type": "application/json", "Authorization": 'Bearer ' + user_id.access_token }
        })
        return notesListRes = res.data
    } catch (error) {
        return notesListRes = error.response.data
    }
})


const notesListSlice = createSlice({
    name: 'notesList',
    initialState: {
        data: null,
    },
    extraReducers: (builder) => {
        builder.addCase(notesListTodo.fulfilled, (state, action) => {
            if (action.payload.success) {
                state.data = action.payload;
                // console.log('notesList', state.data)
            }
        });
        builder.addCase(notesListTodo.rejected, (state, action) => {
            // console.log('token_error', action)
        })
    }
});

export default notesListSlice.reducer; 